import { RenderElementProps } from 'slate-react';
import { LayoutElement } from 'slate/types/slate';

type LayoutProps = RenderElementProps & { markEmpty?: boolean };

export const Layout = ({ attributes, element, children, markEmpty }: LayoutProps) => {
  const layout = element as LayoutElement;
  const className = `${layout.className ?? ''} ${
    layout.isLayoutLeaf ? (layout.isEmptyLayoutLeaf && markEmpty ? 'layout-leaf layout-leaf-empty' : 'layout-leaf') : ''
  }`;
  return (
    <div {...attributes} className={className}>
      {children}
    </div>
  );
};
